import React, { useState, useEffect } from 'react';  // <-- Add this line
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {format} from 'date-fns'
import CustomError from '../CustomError';

const List = (props) => {
    const { title } = props;
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);    
    const navigator = useNavigate();        
    let recno = 0;    

    

    useEffect(() => {   
        const fetchItems = async () => {            
            try {
                const response = await axios.get('https://api.plusat.be/invoices');                
                setItems(response.data);
            } catch (err) {
                console.error('Error fetching items:', err);
                setError('Failed to fetch data');
            }
        };

        fetchItems();
    }, []); 


    const getDetails = (id) => {
        navigator(`/invoices/${id}`);    
    }

    const deleteItem = async (id, item) => {        
        const deleteUrl = `https://api.plusat.be/invoices/${id}`;        
        try {
            const response = await axios.delete(deleteUrl);                                    
            if (response.status === 200) {
                setItems(prevItems => prevItems.filter(item => item._id !== id));
                console.log('Item deleted successfully');
            } else {
                console.error('Error deleting item:', response.data.message);
                setError('Failed to delete item');
            }
        } catch (err) {
            console.error('Error deleting item:', err);
            setError('Failed to delete item');
        }
    };
    
    const sendItem = (id) => {
        alert('not yet');
    }

    return (
        <div className="grid">
        <h1>{title}</h1>
            {
                items &&                    
                items.map(item => (
                    <div className="item-outer" key={item._id}>
                        <div className="item-header" onClick={() => getDetails(item._id)}>                        
                            <strong className='item-no'>{++ recno}.</strong>                        
                            <div className="item">
                                <span>{item.invoiceNo}</span>
                                <span className='invoice-client'>{item.invoiceClient}</span>
                                <span>{format(new Date(item.invoiceDate), "MMMM dd, yyyy")}</span>
                                <span>{item.invoiceAmount} EUR</span>
                                
                            </div>                                                    
                        </div>                        
                        <button onClick={() => deleteItem(item._id, item)}>delete</button>
                        <button onClick={() => sendItem(item._id)}>send</button>
                    </div>
                ))                
            }       
            
            {error && <CustomError error={error}/>}
        </div>
    );
}

export default List;